<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/141PUI6/tc-custom/9781504098922.jpg?1728353129605" alt="This image is the cover for the book Dark Waters"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dark Waters
      </h1>
      <p class="bookDescription body article font2">
        <b>A modern woman confronts a nineteenth-century mystery in this haunting novel of tragedy, trapped spirits, and moving on from the past . . .</b><br/><br/> Michelle left Australia to begin a new life in London away from the pain caused by her cheating husband and her own infertility. But one thing hasn’t changed: her ability to see and speak to the dead.<br/><br/> When she encounters Ned, who died in 1848, Michelle wonders what unresolved business keeps his spirit from eternal rest. And as she explores Ned’s past, she learns of the tragic fate of Clara, Ned’s lover.<br/><br/> But now that Michelle knows what haunts Ned, can she help free him—and herself at the same time?<br/><br/><i>Dark Waters</i> is a haunting debut novel about finding hope for the future by learning to set yourself free from the sins of the past.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Deborah Siddoway
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?14fbcbce